<ion-menu class="menu_main" side="start" content-id="content" menuId='main'>
  <ion-header>

  </ion-header>
  <ion-content>
    <ion-menu-toggle auto-hide="false">
      <div class="wrap">
        <app-drawer-content>
        </app-drawer-content>
      </div>
    </ion-menu-toggle>
  </ion-content>
</ion-menu>
<!-- <ion-menu-controller></ion-menu-controller> -->

<ion-content id="content">
  <div class=" nav_on_home" *ngIf="router.url != '/'">
    <div class="nav_container_bars_and_back">
      <ion-menu-toggle auto-hide="false">
        <fa-icon [icon]="faBars" class="menu"></fa-icon>
      </ion-menu-toggle>
      <div class="nav_container_back">
        <a [routerLink]="['/home']" routerLinkActive="router-link-active" class="home" *ngIf="router.url != '/home'">
          <fa-icon [icon]="faHome"></fa-icon>
        </a>
        <a (click)="goBack()" *ngIf="router.url != '/home'">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
        </a>
      </div>
    </div>

    <app-nav></app-nav>

  </div>
  <div [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''" class="content">
    <router-outlet #o="outlet"></router-outlet>
  </div>
</ion-content>


<!-- <mat-drawer-container class="nav_container" (panleft)="swipeLeft()" (panright)="swipeRight()">
  <mat-drawer #drawer>
    <app-drawer-content (click)="drawer.toggle()">
    </app-drawer-content>
  </mat-drawer>
  <mat-drawer-content>
    <div class=" nav_on_home" *ngIf="router.url != '/'">
      <div class="nav_container_bars_and_back">
        <div class="nav_container_bars" mat-raised-button (click)="drawer.toggle()">
          <fa-icon [icon]="faBars" class="menu"></fa-icon>
        </div>
        <div class="nav_container_back">
          <a [routerLink]="['/home']" routerLinkActive="router-link-active" class="home" *ngIf="router.url != '/home'">
            <fa-icon [icon]="faHome"></fa-icon>
          </a>
          <a (click)="goBack()" *ngIf="router.url != '/home'">
            <fa-icon [icon]="faArrowLeft"></fa-icon>
          </a>
        </div>
      </div>
      <app-nav></app-nav>
    </div>
    <div [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''">
      <router-outlet #o="outlet"></router-outlet>
    </div>
  </mat-drawer-content>
</mat-drawer-container> -->